import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
export * from './tdk';
export * from './og';
export * from './fb-al-meta';
export * from './tw';
export class AbsPageSharingCard extends Component {
    render() {
        const { PageLevelTDK, PageLevelALMeta, PageLevelOGCard, PageLevelTWCard } = this;
        return (_jsxs(_Fragment, { children: [_jsx(PageLevelTDK, {}), _jsx(PageLevelOGCard, {}), _jsx(PageLevelALMeta, {}), _jsx(PageLevelTWCard, {})] }));
    }
}
